// District feature gate: server-set featureFlags.classlink on a district admin.
// No isSuperAdmin bypass (real district users commonly carry it).
export const hasClasslinkAccess = (profile) =>
  !!profile && profile.role === 'districtAdmin' && !!(profile.featureFlags && profile.featureFlags.classlink === true);

// CoPilot staff gate for connection-level controls (tenant link, enable).
export const isClasslinkAdmin = (profile) =>
  !!profile && !!(profile.featureFlags && profile.featureFlags.classlinkAdmin === true);

export default 'access.js';
